var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 1.25H1.875C0.839844 1.25 0 2.08984 0 3.125V16.875C0 17.9102 0.839844 18.75 1.875 18.75H18.125C19.1602 18.75 20 17.9102 20 16.875V3.125C20 2.08984 19.1602 1.25 18.125 1.25ZM14.8594 12.5977C15.0469 12.7852 15.0469 13.0898 14.8594 13.2773L13.2773 14.8594C13.0898 15.0469 12.7852 15.0469 12.5977 14.8594L10 12.2383L7.40234 14.8594C7.21484 15.0469 6.91016 15.0469 6.72266 14.8594L5.14063 13.2773C4.95313 13.0898 4.95313 12.7852 5.14063 12.5977L7.76172 10L5.14063 7.40234C4.95313 7.21484 4.95313 6.91016 5.14063 6.72266L6.72266 5.14063C6.91016 4.95313 7.21484 4.95313 7.40234 5.14063L10 7.76172L12.5977 5.14063C12.7852 4.95313 13.0898 4.95313 13.2773 5.14063L14.8594 6.72266C15.0469 6.91016 15.0469 7.21484 14.8594 7.40234L12.2383 10L14.8594 12.5977Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.f8878063.svg";
export { ForwardRef as ReactComponent };